import { useRef } from "react";
import { useTeamList, usePopupOutsideClose } from "../../lib/hooks";
import classNames from "classnames";
import Icon from "../ds/Icon";

const { useSelector, useDispatch } = require("react-redux");


const LeadFilter = ({ teamList, lead }) => {
    const dispatch = useDispatch();
    const userFilter = useSelector(st => st.tickets.userFilter);

    const toggleItem = (e) => {
        const email = e.target.value;
        const user = teamList.find(item => item.email === email);
        let userList = [];
        if (!userFilter.some(item => item.email === user.email)) {
            userList = [...userFilter, user];
        } else {
            userList = userFilter.filter(item => item.email !== email);
        }
        dispatch({ type: 'filter_users', users: userList });
    };

    const changeTree = (path) => {
        let userList = [];
        const user = teamList.find(item => item.path === path);
        const team = teamList.filter(item => item.path.indexOf(path) >= 0);

        if (!userFilter.some(item => item.email === user.email)) {
            userList = [...userFilter, user, ...team];
        } else {
            userList = userFilter.filter(item => item.path.indexOf(path) === -1);
        }
        dispatch({ type: 'filter_users', users: userList });
    };

    return (
        <div className="ds-tree">
            {teamList.filter(item => item.teamLead === lead).map(item => {
                const showChildren = userFilter.some(uf => uf.path.indexOf(`#${item.username}#`) >= 0 || uf.email === item.email);
                const count = teamList.filter(u => u.path.indexOf(`${item.username}#`) > 0).length;
                return (
                    <div key={item.username}>
                        <div className="ds-tree__row" title={item.email}>
                            <input
                                type="checkbox"
                                className="ds-tree__check"
                                onChange={toggleItem}
                                value={item.email}
                                aria-label={`Select ${item.name}`}
                                checked={userFilter.some(uf => uf.email === item.email)}
                            />
                            <button
                                type="button"
                                className="ds-tree__toggle"
                                onClick={() => changeTree(item.path)}
                                title={`Toggle immediate team of ${item.name}`}
                            >
                                <span>
                                    {item.name}
                                    {count > 0 && <span className="ds-tree__count">&nbsp;({count + 1})</span>}
                                </span>
                                {count > 0 && (
                                    <Icon name="chevronRight" className={classNames("ds-tree__caret", { "is-open": showChildren })} />
                                )}
                            </button>
                        </div>
                        {showChildren && (
                            <div className="ds-tree__children">
                                <LeadFilter key={item.email} teamList={teamList} lead={item.email} />
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export const TeamFilter = () => {
    const dispatch = useDispatch();
    const teamList = useTeamList([]);
    const { userFilter, modalStatus } = useSelector(st => ({
        userFilter: st.tickets.userFilter,
        modalStatus: st.modalStatus,
    }));

    const isOpen = modalStatus.popupName === 'team-filter';
    const ref = useRef(null);
    usePopupOutsideClose(ref, isOpen);

    const toggleFilter = () => {
        dispatch({ type: 'popup', name: isOpen ? '' : 'team-filter' });
    };
    const clearFilter = () => {
        dispatch({ type: 'filter_users', users: [] });
    };

    return (
        <div className="ds-dropdown" ref={ref}>
            <button
                type="button"
                onClick={toggleFilter}
                className="ds-btn is-ghost is-icon"
                aria-label="Filter by team"
                aria-haspopup="true"
                aria-expanded={isOpen}
                title="Team filter"
            >
                <Icon name="filter" />
            </button>
            <div className={classNames("ds-dropdown__panel", { "is-open": isOpen })}>
                <div className="ds-dropdown__head">
                    <span className="ds-label" style={{ margin: 0 }}>Filter people</span>
                    <button
                        type="button"
                        className="ds-btn is-soft is-sm"
                        disabled={userFilter.length === 0}
                        onClick={clearFilter}
                    >
                        Clear{userFilter.length > 0 ? ` (${userFilter.length})` : ''}
                    </button>
                </div>
                <LeadFilter key="null" teamList={teamList} lead={''} />
                <LeadFilter key="empty" teamList={teamList} lead={null} />
            </div>
        </div>
    );
};
